import React, { Fragment } from "react";
import {
    Button,
    colors,
    Container,
    Grid,
    Paper,
    TextField,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import InvoiceOilFilter from "./InvoiceOilFilter";
import { useStylesTF, useStylesLbl
} from '../../../../St/Reports/UseStyle';

export default function InvoiceOilItems(props) {
    const {
        fromQountity,
        setfromQountity,
        selectOilType,
        subInfo,
        changInfo,
        getrowDataCurrencie,
        valuePumps,
        AutoOptions,
        idata,
        onChangeData
    } = props;
    const clasTF = useStylesTF();
    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: colors.green[300],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    {AutoOptions?.permType?.id === 4 ?
                        (
                            <>
                                <InvoiceOilFilter {...{
                                    fromQountity,
                                    setfromQountity,
                                    selectOilType,
                                }} />
                                <Fragment>
                                    <Grid item container justifyContent="center" xs={12} spacing={1}>


                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={"اسم المضخة"}
                                                className={clasTF.rootSale}
                                                InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="text"
                                                name="pump"
                                                value={valuePumps?.name}
                                            /></Grid>

                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={t("item-name")}
                                                className={clasTF.rootSale}
                                                InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="text"
                                                name="symbol"
                                                value={subInfo.symbol}
                                            /></Grid>
                                        {fromQountity.select.id == 1 &&
                                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                <TextField fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    id="number"
                                                    label={"اللترات"}
                                                    className={clasTF.rootSaleOil}
                                                    InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                    InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                    type="number"
                                                    name="val1"
                                                    value={subInfo.val1}
                                                /></Grid>

                                        }
                                        {fromQountity.select.id == 1 &&
                                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                <TextField fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    id="symbol"
                                                    label={t("price")}
                                                    className={clasTF.rootSaleOil}
                                                    InputProps={{ className: claslbl.clrSaleOil }}
                                                    InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                    type="number"
                                                    name="totJust1"
                                                    value={subInfo?.totJust1}
                                                    onChange={changInfo("totJust1")}

                                                /></Grid>

                                        }
                                        {fromQountity.select.id == 2 &&
                                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                <TextField fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    id="totJust"
                                                    label={t("price")}
                                                    className={clasTF.rootSaleOil}
                                                    InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                    InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                    type="number"
                                                    name="totJust"
                                                    value={subInfo?.totJust}
                                                /></Grid>

                                        }
                                        {fromQountity.select.id == 2 &&
                                            <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                <TextField fullWidth
                                                    variant="outlined"
                                                    size="small"
                                                    id="val1"

                                                    label={"اللترات"}
                                                    className={clasTF.rootSaleOil}
                                                    InputProps={{ className: claslbl.clrSaleOil, }}
                                                    InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                    type="number"
                                                    name="valOil"
                                                    value={subInfo.valOil}
                                                    onChange={changInfo("valOil")}

                                                /></Grid>

                                        }
                                        {fromQountity.select.id == 3 &&
                                            < >
                                                <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                    <TextField fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        id="totJust"
                                                        label={t("price")}
                                                        className={clasTF.rootSaleOil}
                                                        InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                        InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                        type="number"
                                                        name="totJust"
                                                        value={subInfo?.totJust}
                                                    /></Grid>
                                                <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                    <TextField fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        id="number"
                                                        label={"اللترات"}
                                                        className={clasTF.rootSaleOil}
                                                        InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                        InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                        type="number"
                                                        name="val1"
                                                        value={subInfo.val1}
                                                    /></Grid>
                                                <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                    <TextField fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        id="val1"
                                                        label={"القراءة السابقة"}
                                                        className={clasTF.rootSaleOil}
                                                        InputProps={{ className: claslbl.clrSaleOil, }}
                                                        InputLabelProps={{ className: claslbl.clrSaleLabelOil, readOnly: true }}
                                                        type="number"
                                                        name="valOil"
                                                        value={subInfo?.count}
                                                        onChange={changInfo("oldCount")}

                                                    /></Grid>

                                                <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                                    <TextField fullWidth
                                                        variant="outlined"
                                                        size="small"
                                                        id="val1"

                                                        label={"القراءة الحالية"}
                                                        className={clasTF.rootSaleOil}
                                                        InputProps={{ className: claslbl.clrSaleOil, }}
                                                        InputLabelProps={{ className: claslbl.clrSaleLabelOil, }}
                                                        type="number"
                                                        name="valOil"
                                                        value={subInfo?.newCount}
                                                        onChange={changInfo("newCount")}

                                                    /></Grid>
                                            </>

                                        }

                                        <br />
                                        <br />
                                        <br />
                                        {/* <br /> */}
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Button
                                                fullWidth
                                                autoFocus
                                                variant="contained"
                                                color="primary"
                                                className={clasTF.rootSaleOil}

                                                onClick={getrowDataCurrencie}

                                                style={{
                                                    background: colors.green[500],
                                                    ...{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                    },
                                                }}
                                            //startIcon={<ArrowDownwardIcon />}
                                            >
                                                {"متابعة"}
                                            </Button>
                                        </Grid>

                                    </Grid>

                                </Fragment>
                            </>
                        ) :
                        (
                            <>
                                <Fragment>
                                    <Grid item container justifyContent="center" xs={12} spacing={1}>

                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={t("item-name")}
                                                className={clasTF.rootSale}
                                                InputProps={{ className: claslbl.clrSaleOil, readOnly: true }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="text"
                                                name="symbol"
                                                value={subInfo.symbol}
                                            /></Grid>


                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={t("note")}
                                                className={clasTF.rootSale}
                                                InputProps={{ className: claslbl.clrSaleOil }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="text"
                                                name="notes"
                                                value={idata?.notes}
                                                onChange={onChangeData("notes")}
                                            /></Grid>


                                        <Grid item lg={6} md={6} sm={12} xs={12} style={{ paddingBottom: "1rem" }}>
                                            <TextField fullWidth
                                                variant="outlined"
                                                size="small"
                                                id="symbol"
                                                label={t("price")}
                                                className={clasTF.rootSaleOil}
                                                InputProps={{ className: claslbl.clrSaleOil }}
                                                InputLabelProps={{ className: claslbl.clrSaleLabelOil }}
                                                type="number"
                                                name="totJust2"
                                                value={subInfo?.totJust2}
                                                onChange={changInfo("totJust2")}

                                            /></Grid>
                                        <br />
                                        <br />
                                        <br />
                                        {/* <br /> */}
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Button
                                                fullWidth
                                                autoFocus
                                                variant="contained"
                                                color="primary"
                                                className={clasTF.rootSaleOil}

                                                onClick={getrowDataCurrencie}

                                                style={{
                                                    background: colors.green[500],
                                                    ...{
                                                        paddingLeft: 0,
                                                        paddingRight: 0,
                                                    },
                                                }}
                                            >
                                                {"متابعة"}
                                            </Button>
                                        </Grid>

                                    </Grid>

                                </Fragment>

                            </>
                        )}


                </Container>


            </Grid>
        </React.Fragment>
    );
}
